import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectComponent } from '@shared/components/select/select.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-select',
	imports: [SharedModule, SelectComponent, UiCodeBlockComponent],
	templateUrl: './ui-select.component.html',
	styleUrl: './ui-select.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSelectComponent {
	@Input() selectControl!: FormControl;
	@Input() disabledSelectControl!: FormControl;
	@Input() errorSelectControl!: FormControl;

	// Sample options for examples
	countryOptions = [
		{ label: 'Andorra', value: 'ad' },
		{ label: 'España', value: 'es' },
		{ label: 'Emiratos Árabes Unidos', value: 'ae' },
		{ label: 'Francia', value: 'fr' },
		{ label: 'Alemania', value: 'de' },
		{ label: 'Italia', value: 'it' },
		{ label: 'Portugal', value: 'pt' },
		{ label: 'Reino Unido', value: 'gb' },
		{ label: 'Suiza', value: 'ch' },
		{ label: 'Países Bajos', value: 'nl' },
	];

	generateCode(attrs: {
		formControl?: string;
		options?: string;
		placeholder?: string;
		label?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
		filter?: boolean;
		filterPlaceholder?: string;
	}): string {
		let code = '<app-select';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.options) code += `\n    [options]="${attrs.options}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;
		if (attrs.filter) code += `\n    [filter]="true"`;
		if (attrs.filterPlaceholder) code += `\n    filterPlaceholder="${attrs.filterPlaceholder}"`;

		code += '\n/>';
		return code;
	}
}
